import Download from '@crehana/compass.icons.outline/Download';
import { Button } from '@crehana/compass.ui/v3/button';
import {
  PageLayout,
  PageLayoutBreadcrumb,
  PageLayoutContent,
  PageLayoutTop,
} from '@crehana/compass.web/page-layout';

import { PageHeaderWithActions } from '@/shared/components/page-header-with-actions';
import type { TRoutePathnames } from '@/shared/modern-router';

import { HoursCalculationContent } from './hours-calculation-content';
import { useAddI18nLocales, useTranslation } from './i18n';

export const HoursCalculationPage = () => {
  useAddI18nLocales();
  const { t } = useTranslation();

  const breadcrumbItems: Array<{
    href: TRoutePathnames | (string & {});
    navigationType: 'client-side' | 'external';
    text: string;
  }> = [
    {
      href: '/ingresar/',
      navigationType: 'client-side',
      text: t('BREADCRUMB_HOME'),
    },
    {
      href: '/org/[slug]/attendance/admin/shifts/',
      navigationType: 'external',
      text: t('BREADCRUMB_ATTENDANCE'),
    },
    {
      href: '/org/[slug]/attendance/admin/hours-calculation/',
      navigationType: 'external',
      text: t('BREADCRUMB_HOURS_CALCULATION'),
    },
  ];

  const handleDownloadReport = () => {
    // TODO: Implement report download (v2 scope)
    console.log(t('DOWNLOAD_COMING_SOON'));
  };

  return (
    <PageLayout
      metadata={{
        title: t('SEO_PAGE_TITLE'),
        description: t('SEO_PAGE_DESCRIPTION'),
      }}
    >
      <PageLayoutTop>
        <PageLayoutBreadcrumb items={breadcrumbItems} />

        <PageHeaderWithActions
          title={t('PAGE_TITLE')}
          subtitle={t('PAGE_DESCRIPTION')}
          actions={
            <Button
              type="button"
              variant="neutral"
              onClick={handleDownloadReport}
              className="tw-shrink-0"
              size="sm"
            >
              <Download size={18} className="tw-text-current" />
              {t('CTA_DOWNLOAD_REPORT')}
            </Button>
          }
        />
      </PageLayoutTop>

      <PageLayoutContent>
        <HoursCalculationContent />
      </PageLayoutContent>
    </PageLayout>
  );
};
